// 用户认证
import Service from '../base'
export default {
  current: function () {
    return Service.get('/user/current')
  },
  isadmin () {
    return Service.post('/eberuser/userapi/user/user/isadmin')
  },
  save (user) {
    return Service.post('/eberuser/userapi/user/user/save', user)
  },
  updateMobile (options) {
    return Service.post('/eberuser/userapi/user/user/updateMobile', options)
  },
  updatePassword (options) {
    return Service.post('/eberuser/userapi/user/user/updatePassword', options)
  },
  updatePasswordByMobileCode (options) {
    return Service.post('/eberuser/userapi/user/user/updatePasswordByMobileCode', options)
  },
  hasMobile (options) {
    return Service.post('/eberuser/userapi/user/user/hasMobile', options)
  },
  register (options) {
    return Service.post('/eberuser/userapi/user/user/register', options)
  },
  delete (options) {
    return Service.post('/eberuser/userapi/user/user/delete', options)
  },
  load (options) {
    return Service.post('/eberuser/userapi/user/user/load', options)
  },
  list (options) {
    return Service.post('/eberuser/userapi/user/user/list', options)
  },
  find (pagination, options) {
    return Service.post('/eberuser/userapi/user/user/find', Service.paginationBody(options, pagination))
  }
}
